import BatteryListModal from './battery-list-modal.connect'

export default BatteryListModal
